export type Tab =
    | 'products'
    | 'collections'
    | 'categories'
    | 'home-sliding-photos'
    | 'users'
    | 'orders'
    | 'reviews'
    | 'visits'
    | 'newsletter';

export const DASHBOARD_TABS: {
    id: Tab;
    translationKey: string;
}[] = [
    {
        id: 'categories',
        translationKey: 'admin.dashboard.categories',
    },
    {
        id: 'collections',
        translationKey: 'admin.dashboard.collections',
    },
    {
        id: 'products',
        translationKey: 'admin.dashboard.products',
    },
    {
        id: 'orders',
        translationKey: 'admin.dashboard.orders',
    },
    {
        id: 'home-sliding-photos',
        translationKey: 'admin.dashboard.home-sliding-photos',
    },
    {
        id: 'users',
        translationKey: 'admin.dashboard.users',
    },
    {
        id: 'reviews',
        translationKey: 'admin.dashboard.reviews',
    },
    {
        id: 'visits',
        translationKey: 'admin.dashboard.visits',
    },
    {
        id: 'newsletter',
        translationKey: 'admin.dashboard.newsletter',
    },
];
